<template>
  <div class="template-wrap notes-tool-tip-template">
    <div class="subject">
      <span>Schedule Note</span>
    </div>
    <div class="description">
      <span>{{ data.Comments }} </span>
    </div>

    <div class="data">
      <div class="left">
        <span>Start</span>
        <span> {{ getFormattedDate(data.StartDate) }} </span>
      </div>
      <div class="right">
        <span>End</span>
        <span> {{ getFormattedDate(data.EndDate) }} </span>
      </div>
    </div>
  </div>
</template>
<script>
import { formatNumber } from "devextreme/localization";
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.00");
    },
    getFormattedDate(value) {
      if (value)
        return (
          new Date(value.toISOString().replace("Z", "")).toShortDateString() +
          " - " +
          new Date(value.toISOString().replace("Z", "")).toShortTimeString()
        );
      else return "";
    },
    customBackGroundColor(data) {
      if (data.WOType === "Maintenance") {
        return "#808080";
      }
      return undefined;
    },
  },
};
</script>

<style lang="scss">
.e-tooltip-wrap {
  background-color: white !important;
  width: auto;
  color: black !important;
  padding: 5px;
  .notes-tool-tip-template {
    color: black !important;
    width: auto;
    display: flex;
    flex-direction: column;
    .subject {
      display: flex;
      justify-content: space-between;
      font-size: 14px;

      > span:first-child {
        font-family: Roboto;
        font-weight: 700;
        font-size: 14px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
        color: var(--Colors-Text-text-placeholder, #667085);
      }
    }

    .description {
      padding-top: 5px;
      text-align: start;

      > span:first-child {
        font-family: Roboto;
        font-weight: 400;
        font-size: 12px;
        leading-trim: NONE;
        line-height: 18px;
        letter-spacing: 0%;
        color: var(--Colors-Text-text-placeholder, #667085);
      }
    }

    .data {
      padding-top: 5px;
      display: flex;
      justify-content: space-between;

      // .actual {
      //   padding-left: 25px;
      // }

      > div {
        display: flex;
        flex-direction: column;
        padding: 0;

        > span:first-child {
          font-family: Roboto;
          font-weight: 400;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: var(--Colors-Text-text-placeholder, #667085);
        }

        > span:last-child {
          font-family: Roboto;
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0%;
          color: var(--colors-text-text-secondary-700, #323842);
        }
      }

      .right {
        text-align: right;

        > span {
          padding-left: 20px;
        }
      }
    }
  }
}
</style>
